export const QUERY_DATE_FORMAT = 'yyyy-MM-dd';
export const SHORT_DATETIME_FORMAT = 'dd/MM HH:mm';
export const SHORT_DATE_FORMAT = 'dd/MM HH:mm';
export const LONG_DATETIME_FORMAT = 'dd/MM/y';
export const LONG_DATE_FORMAT = 'dd/MM/y';
